import React from "react";
import LegalLayout from "../../components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      seoPath="/cookie-policy"
      intro="This Cookie Policy explains how Jollof Fit Kingdom uses cookies and similar technologies to recognize you when you visit our website and use our Services, and the choices you have regarding their use."
      sections={[
        {
          heading: "What Are Cookies",
          body: ["Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work, improve efficiency and provide reporting information. Similar technologies include pixels, local storage and SDKs."],
        },
        {
          heading: "Types of Cookies We Use",
          list: [
            "Essential cookies — required for the website and Services to function.",
            "Preference cookies — remember your settings and choices.",
            "Analytics cookies — help us understand how the Services are used so we can improve them.",
            "Security cookies — help protect your account, detect malicious activity and keep the Services secure.",
            "Performance cookies — measure and optimize loading and reliability.",
          ],
        },
        {
          heading: "Why We Use Cookies",
          body: ["We use cookies to operate and secure the Services, remember your preferences, analyze usage and improve performance and user experience."],
        },
        {
          heading: "Analytics & Session Technology",
          body: ["Our website uses PostHog for analytics and session recording to understand how visitors use the site so we can improve it. This may capture page views, interactions and session-replay data in aggregated or pseudonymized form. We do not use this technology to sell your personal data."],
        },
        {
          heading: "Third-Party Cookies",
          body: ["Some cookies may be placed by third-party services we use, such as analytics providers. These third parties may use cookies in accordance with their own policies, which we encourage you to review."],
        },
        {
          heading: "Managing Your Preferences",
          body: ["You can control and delete cookies through your browser settings, and where available, through our on-site cookie controls. Disabling certain cookies may affect the functionality of the Services."],
        },
        {
          heading: "Changes to This Cookie Policy",
          body: ["We may update this Cookie Policy from time to time to reflect changes in technology, law or our practices. The 'Last updated' date above indicates the latest revision."],
        },
      ]}
    />
  );
}
